module.exports = __webpack_public_path__ + "d44a57653433b825e44aa241cebad315.png";